var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.74 46.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HTML5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,0l3.61,40.97,16.21,5.4,16.31-5.4L39.74,0H0Zm31.9,13.24H12.88l.42,5.11h18.17l-1.41,15.36-10.13,2.79v.03h-.11l-10.22-2.83-.62-7.85h4.94l.36,3.94,5.54,1.5,5.56-1.5.62-6.44H8.73l-1.32-15.07h24.95l-.46,4.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml5);
export default __webpack_public_path__ + "static/media/icon_html5.aff35fbc339a16f0057b8c4f2b3c5b0b.svg";
export { ForwardRef as ReactComponent };